<template>
  <div class="search-no-results">
    <div class="search-no-results__image">
      <img src="@/assets/img/components/no-search-results-3.png" />
    </div>
    <span class="search-no-results__text">
      Sin resultados para:
      <span>{{ query }}</span>
    </span>
  </div>
</template>

<script>
export default {
  name: 'SarchNoResults',

  props: {
    query: {
      type: String,
      required: true,
    },
  },
}
</script>

<style scoped>
.search-no-results {
  display: grid;
  align-items: center;
  width: 100%;
  gap: 10px;
  padding: 10px 0;
  text-align: center;
}

.search-no-results__text {
  max-width: 300px;
  margin: 0 auto;
}

.search-no-results__text span {
  font-weight: 700;
  color: var(--c-secondary);
  word-break: break-word;
}
</style>
